import React, { useRef, useEffect, useState } from 'react';
import 'styles/components/common/PageFrame.scss';
import $ from 'jquery';
import { Link } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HeadTitle from 'components/common/HeadTitle';
import menuItems from 'assets/data/menuItems.json';

const PageFrame = ({ subMenuItems, showTab, rest, page }) => {

    const [searchParams, setSearchParams] = useSearchParams();
    const tab = searchParams.get('tab');
    const navigate = useNavigate();
    const moreThan768 = useSelector((state) => state.moreThan768.value);

    const subNavbarEl = useRef(null);
    const titleEl = useRef(null);
    const sectionsEl = useRef(null);
    const sectionEls = useRef([]);
    let lastScrollY = 0;

    let positions = {};
    const scrollPos = $(window).scrollTop();
    let pageRatio = 0.85; // 메뉴 활성화 변경 포인트 페이지 위치

    /**
     * 메인에서 탭이름 클릭 시 해당 탭 위치로 이동시켜주는 함수
     */
    const moveToTab = () => {
        let newTabs = [];
        menuItems.map(item => newTabs.push(...item.tabs));

        const targetTab = newTabs.find(tabItem => tab === tabItem.name);
        if (targetTab) {
            setSearchParams({ tab: targetTab.name });
            sectionEls.current[targetTab.id].scrollIntoView({ behavior: 'smooth' });
        }
    }

    /**
     * 화면에 보이는 탭에 따라 서브메뉴의 해당 탭 활성화하는 함수
     */
    const makeActive = () => {
        const subMenuLength = Object.keys(positions).length;
        $('.subMenuItem').removeClass('active');

        for (let i = 0; i < subMenuLength; i++) {
            const prevPos = positions['pos' + (i)];
            const curPos = positions['pos' + (i + 1)];
            const nextPos = positions['pos' + (i + 2)];
            if (i === 0) {
                if (scrollPos >= 0 && scrollPos < curPos + (nextPos - curPos) * pageRatio) {
                    $('.subMenuItem').eq(i).addClass('active')
                }
            } else {
                if (i < subMenuLength - 1) {
                    if (scrollPos >= prevPos + ((curPos - prevPos) * pageRatio) && scrollPos < curPos + ((nextPos - curPos) * pageRatio)) {
                        $('.subMenuItem').eq(i).addClass('active');
                    }
                } else {
                    if (scrollPos >= prevPos + ((curPos - prevPos) * pageRatio)) {
                        $('.subMenuItem').eq(i).addClass('active');
                    }
                }
            }
        }
    }

    /**
     * 전체 section 높이 외 여백 제거하는 함수
     */
    const handleSectionsHeight = () => {
        let HeightSum = 0;
        for (let i = 0; i < sectionEls.current.length; i++) {
            HeightSum += sectionEls.current[i].getBoundingClientRect().height - (i * 15 + rest);
        }
        sectionsEl.current.style.height = HeightSum + 'px'
    }


    /**
     * 스크롤 방향 감지하는 함수
     * @param {event} e event
     */
    const handleScroll = e => {
        const navbarEl = document.querySelector('.Navbar');
        const scrollY = window.scrollY;
        const titleElBottom = window.pageYOffset + titleEl.current.getBoundingClientRect().bottom;
        const direction = scrollY > lastScrollY ? 'scroll Down' : 'scroll Up';
        lastScrollY = scrollY;
        if (direction === 'scroll Down' && lastScrollY > titleElBottom) {
            subNavbarEl.current.classList.add('scrolled');
            navbarEl.classList.add('scrolled');
        } else if (direction === 'scroll Up') {
            subNavbarEl.current.classList.remove('scrolled');
            navbarEl.classList.remove('scrolled');
        }
    };

    useEffect(() => {
        subMenuItems.forEach(function (el) {
            positions['pos' + (el.id + 1)] = $(`#item${el.id + 1}`).offset().top - 100;
        })
        makeActive();
    });

    const [tabName, setTabName] = useState('');

    useEffect(() => {
        const activatedSubMenuItem = document.querySelector('.subMenuItem.active').dataset.name;
        if (tabName !== activatedSubMenuItem) {
            setTabName(activatedSubMenuItem);
        }
    });

    useEffect(() => {
        setSearchParams({ tab: tabName });
    }, [tabName]);

    useEffect(() => {
        moveToTab();
    }, []);

    useEffect(() => {
        const options = {};
        const arrowUpBtn = document.querySelector(".upArrowBtn");

        /**
         * 페이지 하단의 상단 바로가기 화살표 버튼 보이기/숨기기 기능 함수
         */
        const initObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    arrowUpBtn.classList.add("invisible");
                    arrowUpBtn.classList.remove("visible");
                } else {
                    arrowUpBtn.classList.add("visible");
                    arrowUpBtn.classList.remove("invisible");
                }
            })
        }, options);

        initObserver.observe(titleEl.current);
        return () => initObserver.disconnect();
    }, []);

    useEffect(() => {
        handleSectionsHeight();
        window.addEventListener('resize', handleSectionsHeight);
        return () => {
            window.removeEventListener('resize', handleSectionsHeight);
        }
    }, [rest]);

    // 스크롤 방향 감지
    useEffect(() => {
        if (moreThan768) {
            handleScroll();
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            }
        } else {
            const navbarEl = document.querySelector('.Navbar');
            navbarEl.classList.remove('scrolled');
            subNavbarEl.current.classList.remove('scrolled');
        }

    }, [moreThan768]);

    return (
        <section className='PageFrame' id='PageFrame'>
            <header className="PageFrame-title" ref={titleEl}>
                <HeadTitle page={page} />
            </header>
            <div className='SubNavbar' ref={subNavbarEl}>
                <div className="subMenuItems">
                    {
                        subMenuItems.map((subMenuItem) =>
                            <Link to={`item${subMenuItem.id + 1}`} key={subMenuItem.id}>
                                <div className="subMenuItem" onClick={() => navigate(`${subMenuItem.link}`)} data-name={subMenuItem.name}>{subMenuItem.koName}</div>
                            </Link>
                        )
                    }
                </div>
            </div>
            <div className="sections" ref={sectionsEl}>
                {subMenuItems.map((subMenuItem) => <section className={`section section${subMenuItem.id + 1}`} id={`item${subMenuItem.id + 1}`} ref={el => (sectionEls.current[subMenuItem.id] = el)} key={subMenuItem.id}>
                    {showTab(subMenuItem.id)}
                </section>)}
            </div>
            <Link to='PageFrame'>
                <button className='upArrowBtn'><FontAwesomeIcon icon={faArrowUp} size='1x' /></button>
            </Link>
        </section>
    );
};

export default React.memo(PageFrame);